import { z } from 'zod';
import { LevelDefinition } from 'libs/end-to-end/src/types/databases/dimensions/level-definition';

export type GetLevelByColumnValueFn = (
  columnHeaderValue: string,
  columnValue: string,
) => LevelDefinition | undefined;

export const GetPrivilegedLevelForDimensionFn = z
  .function()
  .args(z.string())
  .returns(z.union([LevelDefinition, z.undefined()]));

export type GetPrivilegedLevelForDimensionFn = z.infer<
  typeof GetPrivilegedLevelForDimensionFn
>;

export const BlueRoundedTriangleConfig = 'BlueRoundedTriangleSvg';
export const PurpleCircleConfig = 'PurpleCircleSvg';
export const GreenCircleOutlineConfig = 'GreenCircleOutlineSvg';
export const GreyTriangleCircleCutoutConfig = 'GreyTriangleCircleCutoutSvg';
export const GreenTriangleTriangleCutoutConfig =
  'GreenTriangleTriangleCutoutSvg';
export const BlueCircleTriangleCutoutConfig = 'BlueCircleTriangleCutoutSvg';
export const OrangeDiamondCircleCutoutConfig = 'OrangeDiamondCircleCutoutSvg';
export const GenderMaleIconConfig = 'GenderMaleIconSvg';
export const GenderFemaleIconConfig = 'GenderFemaleIconSvg';
export const GenderOtherIconConfig = 'GenderOtherIconSvg';

export const DimensionConfigIcon = z.enum([
  BlueRoundedTriangleConfig,
  PurpleCircleConfig,
  GreenCircleOutlineConfig,
  GreyTriangleCircleCutoutConfig,
  GreenTriangleTriangleCutoutConfig,
  BlueCircleTriangleCutoutConfig,
  OrangeDiamondCircleCutoutConfig,
  GenderMaleIconConfig,
  GenderFemaleIconConfig,
  GenderOtherIconConfig,
]);

export type DimensionConfigIcon = z.infer<typeof DimensionConfigIcon>;
